import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ChargesService } from 'src/app/services/charges.service';
import { LoadingOverlayService } from 'src/app/shared/loading-overlay/loading-overlay.service';

@Component({
    selector: 'app-campaign-add-charges-modal',
    templateUrl: './campaign-add-charges-modal.component.html',
    styleUrls: ['./campaign-add-charges-modal.component.scss']
})
export class CampaignAddChargesModalComponent implements OnInit {
    public form: FormGroup;
    public campaignId: string;
    dataSource = null;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    totalCharges;
    totalAdditionalCharges = 0;
    currenciesConversionRate;
    step = 1;

    columns = ['cityName', 'value', 'additionalMFAmount'];
    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<CampaignAddChargesModalComponent>,
        private loadingOverlayService: LoadingOverlayService,
        private chargesService: ChargesService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.campaignId = data.campaignId;
    }

    ngOnInit(): void {
        this.getTotalChargesPerCities();
    }

    editCharge(row, event: Event) {
        const value = (event.target as HTMLInputElement).valueAsNumber;
        const cityId = row.cityId;

        const element = this.dataSource.data.find(item => item.cityId === cityId);

        if (element && !Number.isNaN(value) && value > 0) {
            element.additionalMFAmount = value;
        } else {
            element.additionalMFAmount = null;
        }

        this.dataSource.data = [...this.dataSource.data];
        this.getCurrentTotalCharges();
    }

    addCharges(rows, campaignId) {
        this.loadingOverlayService.show();
        const filteredRows = rows
            .filter(row => row.additionalMFAmount != null)
            .map(row => ({
                cityId: row.cityId,
                additionalMFAmount: {
                    currencyId: row.totalChargesOfCity.currencyId,
                    currencyCode: row.totalChargesOfCity.currencyCode,
                    value: row.additionalMFAmount
                }
            }));
        this.chargesService.addCharges(filteredRows, campaignId).subscribe(_ => {
            this.loadingOverlayService.hide();
            this.dialogRef.close();
        });
    }

    convertAdditionalChargeToDollars(item) {
        if (item.conversionRate) {
            return item.additionalMFAmount / item.conversionRate;
        } else {
            return item.additionalMFAmount;
        }
    }

    getCurrentTotalCharges() {
        this.totalAdditionalCharges = this.dataSource.data.reduce(
            (acc, item) => acc + (Number(this.convertAdditionalChargeToDollars(item)) || 0),
            0
        );
    }

    isDisabled() {
        return this.dataSource?.data.every(ds => {
            const value = ds.additionalMFAmount;
            return value == null || isNaN(value) || value <= 0;
        });
    }

    moveToStepTwo() {
        this.dialogRef.updateSize('500px');
        return (this.step = 2);
    }

    getTotalChargesPerCities() {
        this.chargesService.getTotalChargesByCities(this.campaignId).subscribe((response: any) => {
            this.dataSource = new MatTableDataSource(response.content);
            this.dataSource.sort = this.sort;
            this.dataSource.sortingDataAccessor = (item, property) => {
                switch (property) {
                    case 'value':
                        return item.totalChargesOfCity.value;
                    default:
                        return item[property];
                }
            };
            this.totalCharges = response.totalCampaignCharges;
        });
    }
}
